import React, { useEffect } from 'react'
import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'
import Slider, { SliderThumb } from '@mui/material/Slider'
import { COLOR } from 'constant'

const boxShadow = '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)'
const thumbSize = 40
const colorKnots = '#afafaf'
const CustomizeYearSlider = styled(Slider)(() => ({
  color: '#afafaf',
  height: 2,
  padding: '10px 0',
  position: 'relative',
  '& .MuiSlider-thumb': {
    height: thumbSize,
    width: thumbSize,
    boxShadow: boxShadow,
    // border: `1px solid ${COLOR.DARK}`,
    '&:focus, &:hover, &:active': {
      boxShadow: 'none',
    },
  },
  '& .Mui-active': {
    '&:before': {
      display: 'block',
    },
  },
  '& .MuiSlider-valueLabelOpen': {
    display: 'block',
  },
  '& .MuiSlider-track': {
    border: 'none',
  },
  '& .MuiSlider-rail': {
    opacity: 1,
    backgroundColor: colorKnots,
  },
  '& .MuiSlider-mark': {
    display: 'block',
    backgroundColor: colorKnots,
    height: 12,
    width: 12,
    borderRadius: '50%',
    '&.MuiSlider-markActive': {
      opacity: 1,
      backgroundColor: 'currentColor',
    },
  },
}))
function ThumbComponent(props: any) {
  const { children, value, backgroundColor, textColor, ...other } = props
  return (
    <SliderThumb {...other}>
      {children}
      <Box
        sx={{
          width: `${thumbSize}px`,
          height: `${thumbSize}px`,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '50%',
          position: 'absolute',
          // border: `1px solid ${COLOR.DARK}`,
          background: backgroundColor,
          zIndex: 2,
        }}
      >
        <span style={{ color: value === 0 ? COLOR.DARK : textColor, fontSize: '11px' }} className='thumb-bar'>
          {value}
        </span>
      </Box>
    </SliderThumb>
  )
}
export const YearSlider: React.FC<{
  value: number
  onChange: (value: number) => void
  sliderLimits?: { minYear: number; maxYear: number }
}> = ({ value, onChange, sliderLimits }) => {
  const thumbColor = COLOR.WHITE
  const textThumbColor = COLOR.DARK
  const [isSliderDirty, setIsSliderDirty] = React.useState(false);
  const handleSliderChange = (event: Event, newValue: number | number[]) => {
    setIsSliderDirty(true);
    onChange(newValue as number)
  }
  const marks = [
    {
      value: 2017,
      label: '',
    },
    {
      value: 2018,
      label: '',
    },
    {
      value: 2019,
      label: '',
    },
    {
      value: 2020,
      label: '',
    },
    {
      value: 2021,
      label: '',
    },
    {
      value: 2022,
      label: '',
    },
    {
      value: 2023,
      label: '',
    },
    {
      value: 2024,
      label: '',
    },
  ]



  useEffect(() => {
    if (sliderLimits && (!isSliderDirty || !(value >= sliderLimits.minYear && value <= sliderLimits.maxYear))) {
      !(value >= sliderLimits.minYear && value <= sliderLimits.maxYear) && setIsSliderDirty(false)
      onChange(sliderLimits.maxYear)
    }
  }, [sliderLimits, isSliderDirty])

  return (
    <Box sx={{ width: '100%' }}>
      <Box
        sx={{
          position: 'relative',
          display: 'flex',
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CustomizeYearSlider
          valueLabelDisplay='off'
          slots={{
            thumb: (props) => (
              <>
                <ThumbComponent {...props} value={value} backgroundColor={thumbColor} textColor={textThumbColor} />
                <SliderThumb {...props}>
                  <Box
                    sx={{
                      width: `${thumbSize}px`,
                      height: `${thumbSize}px`,
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      borderRadius: '50%',
                      position: 'absolute',
                      border: `1px solid ${COLOR.DARK}`,
                      background: thumbColor,
                      zIndex: 2,
                    }}
                  >
                    <span
                      style={{ color: value === 0 ? COLOR.DARK : textThumbColor, fontSize: '14px' }}
                      className='thumb-bar'
                    >
                      {value}
                    </span>
                  </Box>
                </SliderThumb>
              </>
            ),
          }}
          aria-label='metric'
          defaultValue={value || 50}
          value={value}
          onChange={handleSliderChange}
          step={1}
          marks={marks}
          min={sliderLimits ? sliderLimits.minYear : 2017}
          max={sliderLimits ? sliderLimits.maxYear : 2024}
        />
      </Box>
    </Box>
  )
}
